import $ from 'jquery';

import * as basketClient from './basket';
import * as addressClient from './address';
import * as checkoutClient from './checkout';
import * as contactClient from './contact';
import * as couponsClient from './coupons';
import * as favoritesClient from './favourites';
import * as miscClient from './misc';
import * as orderClient from './order';
import * as productClient from './product';
import * as userClient from './user';
import * as giftClient from './giftCard';

class ApiClient {
  constructor() {
    this.basket = basketClient;
    this.address = addressClient;
    this.checkout = checkoutClient;
    this.contact = contactClient;
    this.coupons = couponsClient;
    this.favorites = favoritesClient;
    this.misc = miscClient;
    this.order = orderClient;
    this.product = productClient;
    this.user = userClient;
    this.gift = giftClient;
  }

  setBaseUrl(url = '') {
    if (url) {
      this.baseUrl =
        url[url.length - 1] !== '/'
          ? url
          : url.substring(0, url.length - 1);
    }
  }

  setCsrfToken(csrfToken = '') {
    this.csrfToken = csrfToken;
  }

  request(method, url, data, options = {}) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method,
        url,
        data,
        beforeSend: xhr => {
          if (this.csrfToken) {
            xhr.setRequestHeader('X-CSRFToken', this.csrfToken);
          }
        },
        success: (response, status, xhr) => {
          return resolve({ data: response, status, xhr });
        },
        error: errors => {
          return reject(errors);
        },
        ...options,
      });
    });
  }
}

export default new ApiClient();
